<template>
  <NuxtPage />
</template>

<script setup lang="ts">
const { isDark } = useTheme()

// Apply dark class on initial render (SSR-safe)
useHead({
  htmlAttrs: {
    class: computed(() => isDark.value ? 'dark' : ''),
  },
})
</script>
